<template>
  <div class="evaluate">
    <div class="evaluate-title">{{ greetings }}</div>
    <div class="evaluate-star">
      <div class="options">
        <div @click="score(1)" class="item">
          <div>
            <img v-show="!score1Selected" src="../../../../assets/img/EvaluateImg/unscore1.png" />
            <img v-show="score1Selected" src="../../../../assets/img/EvaluateImg/score1.png" />
          </div>
          <span v-if="scoreSet[0]" :class="{ selected: score1Selected }">{{
            scoreSet[0].scoreDesc
          }}</span>
        </div>
        <div @click="score(2)" class="item">
          <div>
            <img v-show="!score2Selected" src="../../../../assets/img/EvaluateImg/unscore2.png" />
            <img v-show="score2Selected" src="../../../../assets/img/EvaluateImg/score2.png" />
          </div>
          <span v-if="scoreSet[1]" :class="{ selected: score2Selected }">{{
            scoreSet[1].scoreDesc
          }}</span>
        </div>
        <div @click="score(3)" class="item">
          <div>
            <img v-show="!score3Selected" src="../../../../assets/img/EvaluateImg/unscore3.png" />
            <img v-show="score3Selected" src="../../../../assets/img/EvaluateImg/score3.png" />
          </div>
          <span v-if="scoreSet[2]" :class="{ selected: score3Selected }">{{
            scoreSet[2].scoreDesc
          }}</span>
        </div>
        <div @click="score(4)" class="item">
          <div>
            <img v-show="!score4Selected" src="../../../../assets/img/EvaluateImg/unscore4.png" />
            <img v-show="score4Selected" src="../../../../assets/img/EvaluateImg/score4.png" />
          </div>
          <span v-if="scoreSet[3]" :class="{ selected: score4Selected }">{{
            scoreSet[3].scoreDesc
          }}</span>
        </div>
        <div @click="score(5)" class="item">
          <div>
            <img v-show="!score5Selected" src="../../../../assets/img/EvaluateImg/unscore5.png" />
            <img v-show="score5Selected" src="../../../../assets/img/EvaluateImg/score5.png" />
          </div>
          <span v-if="scoreSet[4]" :class="{ selected: score5Selected }">{{
            scoreSet[4].scoreDesc
          }}</span>
        </div>
      </div>
    </div>
    <div class="evaluate-options" v-show="optionClick">
      <div
        class="evaluate-options-item"
        :class="{ selected: item.selected }"
        v-for="item in currScore.options"
        :key="item.id"
        @click="checkOpt(item)"
      >
        {{ item.name }}
      </div>
      <div class="empty"></div>
    </div>

    <div class="comment-area" v-if="currScore.score > 0">
      <textarea
        ref="textArea"
        v-model="comment"
        placeholder="有什么想说的可以写在这里哦"
        @focus="inputFocus"
        @input="descChange"
      ></textarea>
      <span class="desc-length">{{ remainDescLength }}</span>
    </div>

    <!-- 按钮 -->
    <div class="evaluate-btn" v-if="currScore.score > 0">
      <div class="evaluate-btn-right" @click="confirmClick">
        确认
      </div>
    </div>
  </div>
</template>
<script>
import { toast } from '../../../../native'

const MAX_DESC_LENGTH = 200

export default {
  name: 'EvaluationComp',
  props: {
    greetings: {
      type: String,
      default: ''
    },
    scores: {
      // 分值列表
      type: Array,
      default: () => []
    },
    onSubmit: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      scoreSet: [],
      currScore: {},
      optionClick: false,
      comment: '' // 留言内容
    }
  },
  mounted() {
    this.initScoreSet(this.scores)
  },
  computed: {
    remainDescLength() {
      return this.comment.length + '/' + MAX_DESC_LENGTH
    },
    score1Selected() {
      return this.currScore.score === '1'
    },
    score2Selected() {
      return this.currScore.score === '2'
    },
    score3Selected() {
      return this.currScore.score === '3'
    },
    score4Selected() {
      return this.currScore.score === '4'
    },
    score5Selected() {
      return this.currScore.score === '5'
    },
    canSubmit() {
      return this.currScore.score > 0
    }
  },
  watch: {
    // 初始化评价星级状态
    scores(newValue) {
      this.initScoreSet(newValue)
    }
  },
  methods: {
    inputFocus() {
      setTimeout(() => {
        this.$refs.textArea.scrollIntoView()
      }, 200)
    },
    descChange() {
      if (this.comment.length > MAX_DESC_LENGTH) {
        this.comment = this.comment.substring(0, MAX_DESC_LENGTH)
      }
    },
    initScoreSet(dataMap) {
      this.scoreSet = dataMap.map((s) => {
        return {
          score: s.score,
          scoreId: s.scoreId,
          scoreDesc: s.scoreDesc,
          options: s.options.map((o) => {
            return {
              id: o.id,
              name: o.name,
              selected: false
            }
          }),
          checked: false
        }
      })
    },
    score(score) {
      this.optionClick = true
      this.$emit('starClick')
      let item = {}
      this.scoreSet.forEach((v) => {
        if (Number(v.score) === score) {
          item = v
        }
      })
      this.scoreSet.forEach((s) => {
        if (s.score <= item.score) {
          s.checked = true
        } else {
          s.checked = false
        }
      })
      this.currScore = item
    },
    // 选项点击
    checkOpt(item) {
      item.selected = !item.selected
    },
    confirmClick() {
      if (!this.canSubmit) {
        toast({
          msg: '请点击星星评价',
          style: '2'
        })
        return
      }
      // 返回选择的星星等级和选项id
      const resultInfo = {
        comment: this.comment,
        score: this.currScore.score,
        scoreId: this.currScore.scoreId,
        optionIds: this.currScore.options
          .filter((opt) => opt.selected)
          .map((opt) => opt.id)
          .join(','),
        optionNames: this.currScore.options
          .filter((opt) => opt.selected)
          .map((opt) => opt.name)
          .join(',')
      }
      this.onSubmit(resultInfo)
    }
  }
}
</script>
<style lang="less" scoped>
  @import './index.less';
</style>
